import { render, staticRenderFns } from "./matrix-input-file.vue?vue&type=template&id=36cb7f84"
import script from "./matrix-input-file.vue?vue&type=script&lang=ts"
export * from "./matrix-input-file.vue?vue&type=script&lang=ts"
import style0 from "./matrix-input-file.vue?vue&type=style&index=0&id=36cb7f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports